export const types = {
  SYNC: "SYNC",
  SYNC_SUCCESS: "SYNC_SUCCESS",
  FETCH_LAST_SYNC_TIME: "FETCH_LAST_SYNC_TIME",
  FETCH_LAST_SYNC_TIME_SUCCESS: "FETCH_LAST_SYNC_TIME_SUCCESS",
  FETCH_LANGUAGE:"FETCH_LANGUAGE"
};
